import React, { useState, useEffect, useRef } from "react";
import moment from "moment-timezone";
import Select from "react-select";
import PersonIcon from "@material-ui/icons/Person";
import EventAvailableIcon from "@material-ui/icons/EventAvailable";
import ScheduleIcon from "@material-ui/icons/Schedule";
import PublicIcon from "@mui/icons-material/Public";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import EditIcon from "@mui/icons-material/Edit";
import Avatar from "@mui/material/Avatar";
import Tooltip from "@mui/material/Tooltip";
import { Slide, toast } from "react-toastify";
import { Col, Row } from "reactstrap";
import { useSelector, useDispatch } from "react-redux";
import axios from "../../axios";
import Axios from "axios";
import {
  USERIMAGEUPDATE,
  HANDLE_ON_CHANGE,
} from "../../redux/CommonInitialsate";
import ct from "countries-and-timezones";
import PlanChip from "./PlanChip";
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Cancel";

const prioritizedCountries = ["US", "GB", "SG", "MY"];

function Balancedays() {
  const [enddate, setEnddate] = useState([]);
  const [countries, setCountries] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [timeZones, setTimeZones] = useState([]);
  const [selectedTimeZone, setSelectedTimeZone] = useState("");
  const [editMode, setEditMode] = useState(false);
  const [utcOffset, setUtcOffset] = useState("");
  const [originalCountry, setOriginalCountry] = useState(null);
  const [originalTimeZone, setOriginalTimeZone] = useState("");

  const dispatch = useDispatch();
  const fileInputRef = useRef(null);

  toast.configure();
  const tenantid = JSON.parse(localStorage.getItem("userdata"));
  const empDetails = JSON.parse(localStorage.getItem("Empdetails"));
  const email = tenantid?.login;
  const roleid =
    sessionStorage.getItem("Roledetails") !== "undefined"
      ? JSON.parse(sessionStorage.getItem("Roledetails"))
      : "";
  const data = JSON.parse(localStorage.getItem("userdata"));
  const token = data?.token;
  const productRole = JSON.parse(localStorage.getItem("ProductRole"));
  const getProdRole = productRole?.find((e) => e.ProdId === 11004)?.RoleCode;
  const getProdRoleName = productRole?.find(
    (e) => e.ProdId === 11004
  )?.RoleName;
  const rolecode =
    localStorage.getItem("Rolecode") !== "undefined"
      ? JSON.parse(localStorage.getItem("Rolecode"))
      : "";
  const id =
    rolecode === "DEV" || getProdRole !== "KA"
      ? JSON.parse(localStorage.getItem("Orgsubscriptiondetails"))?.[0]
          ?.ClientId
      : JSON.parse(localStorage.getItem("clientid"));
  const cid = localStorage.getItem("clientid");
  const userid =
    localStorage.getItem("userid") == undefined
      ? ""
      : JSON.parse(localStorage.getItem("userid"));
  const { projectRole, projectRoleName, userImage, dateformat } = useSelector(
    (state) => state.user
  );

  useEffect(() => {
    const fetchCountries = () => {
      const countryData = ct.getAllCountries(); // Get all country data
      const countryList = Object.keys(countryData).map((code) => ({
        value: code,
        label: countryData[code].name,
        timezones: countryData[code].timezones,
      }));

      const sortedCountries = [
        ...prioritizedCountries.map((code) =>
          countryList.find((country) => country.value === code)
        ),
        ...countryList.filter(
          (country) => !prioritizedCountries.includes(country.value)
        ),
      ];

      setCountries(sortedCountries);

      return sortedCountries;
    };

    const sortedCountries = fetchCountries();

    axios({
      method: "GET",
      url: `${process.env.REACT_APP_API_BASE_URL}/subscription_client_users?ClientUserId=eq.${userid}`,
    })
      .then((response) => {
        const savedDetails = response.data[0]?.UserGeographyData;

        if (savedDetails?.Country && savedDetails?.TimeZone) {
          const savedCountry = sortedCountries.find(
            (country) => country.label === savedDetails.Country
          );
          const savedTimeZone = savedDetails.TimeZone.split(") ")[1];

          if (savedCountry && savedTimeZone) {
            setSelectedCountry(savedCountry);
            setTimeZones(savedCountry.timezones);
            setSelectedTimeZone(savedTimeZone);
            setUtcOffset(moment.tz(savedTimeZone).format("Z"));

            setOriginalCountry(savedCountry);
            setOriginalTimeZone(savedTimeZone);
          }
        } else {
          const india = sortedCountries.find(
            (country) => country.label === "India"
          );
          if (india) {
            setSelectedCountry(india);
            setTimeZones(india.timezones);
            setSelectedTimeZone(india.timezones[0]);
            setUtcOffset(moment.tz(india.timezones[0]).format("Z"));

            setOriginalCountry(india);
            setOriginalTimeZone(india.timezones[0]);
          }
        }
      })
      .catch((error) => {
        console.error("Error fetching user details:", error);
        // In case of error, default to India
        const india = sortedCountries.find(
          (country) => country.label === "India"
        );
        if (india) {
          setSelectedCountry(india);
          setTimeZones(india.timezones);
          setSelectedTimeZone(india.timezones[0]);
          setUtcOffset(moment.tz(india.timezones[0]).format("Z"));

          setOriginalCountry(india);
          setOriginalTimeZone(india.timezones[0]);
        }
      });
  }, []);

  const handleCountryChange = (selectedOption) => {
    setSelectedCountry(selectedOption);
    setTimeZones(selectedOption.timezones);

    if (selectedOption.timezones.length === 1) {
      setSelectedTimeZone(selectedOption.timezones[0]);
      const offset = moment.tz(selectedOption.timezones[0]).format("Z");
      setUtcOffset(offset);
    } else {
      setSelectedTimeZone("");
      setUtcOffset("");
    }
  };

  const handleTimeZoneChange = (selectedOption) => {
    const timeZone = selectedOption.value;
    setSelectedTimeZone(timeZone);

    const offset = moment.tz(timeZone).format("Z");
    setUtcOffset(offset);
  };

  const handleEditClick = () => {
    setEditMode(!editMode);
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    const localAvatarURL = URL.createObjectURL(file);
    dispatch(USERIMAGEUPDATE(localAvatarURL));
    const renamedFile = new File(
      [file],
      `${cid}-${empDetails[0].ClientUserId}_${empDetails[0].UserFirstname}_${empDetails[0].UserLastname}.png`,
      { type: file.type }
    );
    const data = new FormData();
    data.append("file", renamedFile);
    data.append("ClientId", cid);
    data.append("ClientUserId", empDetails[0].ClientUserId);
    axios
      .post("api/agile/filesystem/EmployeeImage", data)
      .then((response) => console.log(JSON.stringify(response.data)))
      .catch((error) => console.log(error));
  };

  const handleAvatarClick = () => {
    fileInputRef.current.click();
  };

  useEffect(() => {
    axios({
      method: "GET",
      url: `${process.env.REACT_APP_API_BASE_URL}/subscription_client_license_details?ClientId=eq.${id}&IsActive=eq.Y`,
    })
      .then((res) => {
        const filteredData = res.data.filter((e) =>
          e.ProductDetails.ProdId === "11006"
            ? res.data
            : res.data.filter((e) => e.ProductDetails.ProdId === "11004")
        );
        setEnddate(filteredData);
      })
      .catch((error) => console.error(error));
  }, [id, token]);

  const handleCancelClick = () => {
    // Revert to the original country and timezone fetched from the API
    setSelectedCountry(originalCountry);
    setTimeZones(originalCountry.timezones);
    setSelectedTimeZone(originalTimeZone);
    setUtcOffset(moment.tz(originalTimeZone).format("Z"));
    setEditMode(false); // Exit edit mode
  };
  const time = enddate?.[0]?.ValidTill;
  const date = moment(enddate?.[0]?.ValidTill).format("DD-MMM-YYYY");
  const userRole =
    projectRole === undefined || projectRoleName === projectRole
      ? getProdRoleName
      : projectRoleName;
  const handlePatchClick = () => {
    const formattedTimeZone = `(UTC${utcOffset}) ${selectedTimeZone}`;

    const payload = {
      UserGeographyData: {
        Country: selectedCountry?.label,
        TimeZone: formattedTimeZone,
      },
    };

    axios({
      method: "PATCH",
      url: `${process.env.REACT_APP_API_BASE_URL}/subscription_client_users?ClientUserId=eq.${userid}`,

      data: payload,
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (response.status === 204) {
          toast.success(`🌍 Country and ⏰ Timezone successfully set!`, {
            transition: Slide,
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 3000,
            draggable: true,
          });

          setOriginalCountry(selectedCountry);
          setOriginalTimeZone(selectedTimeZone);
          setEditMode(false);
        }
      })
      .catch((error) => {
        console.error("Error patching data:", error);
        handleCancelClick();
      });
  };

  return (
    <div style={{ width: "100%", justifySelf: "center", alignSelf: "center" }}>
      <Row
        style={{ padding: "5%", justifySelf: "center", alignSelf: "center" }}
        noGutters
      >
        <Col
          lg={3}
          style={{
            alignContent: "center",
            justifyContent: "center",
            marginTop: "4%",
          }}
        >
          <div>
            <input
              type="file"
              accept="image/*"
              onChange={handleFileChange}
              style={{ display: "none" }}
              ref={fileInputRef}
            />
            <Avatar
              src={userImage}
              alt={`${empDetails?.[0]?.UserFirstname} ${empDetails?.[0]?.UserLastname}`}
              onClick={handleAvatarClick}
              sx={{ width: 60, height: 60, marginRight: "60px" }}
            />
          </div>
        </Col>
        <Col
          lg={9}
          style={{
            alignContent: "center",
            justifyContent: "left",
            marginTop: "4%",
            paddingLeft: 5,
          }}
        >
          <div
            style={{
              maxWidth: "100%",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            <label
              style={{ fontSize: 12, fontWeight: "600" }}
            >{`${empDetails?.[0]?.UserFirstname} ${empDetails?.[0]?.UserLastname}`}</label>
          </div>
          <label style={{ fontSize: 12, fontWeight: "500" }}>{email}</label>
        </Col>
      </Row>

      <div style={{ padding: "1%" }}>
        <PersonIcon style={{ fontSize: 12 }} />
        &nbsp;
        <label style={{ fontSize: 12, fontWeight: "600" }}>
          Logged as &nbsp;: &nbsp;
        </label>
        <label style={{ fontSize: 12 }}>
          {userRole || (empDetails?.[0]?.IsOrgAdmin === "Y" ? "Admin" : "User")}
        </label>
      </div>

      <div style={{ padding: "1%" }}>
        <EventAvailableIcon style={{ fontSize: 12 }} />
        &nbsp;
        <label style={{ fontSize: 12, fontWeight: "600" }}>
          Subscription &nbsp;: &nbsp;
        </label>
        <label style={{ fontSize: 12 }}>
          {enddate != null ? (
            <PlanChip plan={enddate?.[0]?.PlanDetails?.PlanName} />
          ) : null}
        </label>
      </div>

      <div style={{ padding: "1%", whiteSpace: "nowrap" }}>
        <ScheduleIcon style={{ fontSize: 12 }} />
        &nbsp;
        <label style={{ fontSize: 12, fontWeight: "600" }}>
          End by &nbsp;: &nbsp;
        </label>
        <label style={{ fontSize: 12 }}>{`${moment(date).format(
          dateformat
        )} (${moment(time, "YYYY-MM-DDTHH:mm:ss").fromNow()})`}</label>
      </div>

      <div style={{ padding: "1%", whiteSpace: "nowrap" }}>
        <PublicIcon style={{ fontSize: 12 }} />
        &nbsp;
        <label style={{ fontSize: 12, fontWeight: "600" }}>
          Country &nbsp;: &nbsp;
        </label>
        {!editMode ? (
          <>
            <label style={{ fontSize: 12 }}>
              {selectedCountry?.label || "Select a country"}
            </label>
            &nbsp;
            <EditIcon
              style={{ fontSize: 12, cursor: "pointer" }}
              onClick={handleEditClick}
            />
          </>
        ) : (
          <Select
            value={selectedCountry}
            onChange={handleCountryChange}
            options={countries}
            isSearchable={true}
            placeholder="Select a country"
            styles={{ fontSize: 12 }}
          />
        )}
      </div>

      {timeZones && timeZones.length > 0 && (
        <div style={{ padding: "1%", whiteSpace: "nowrap" }}>
          {editMode ? (
            <label style={{ fontSize: 12, fontWeight: "600" }}>
              Time Zone &nbsp;: &nbsp;
            </label>
          ) : null}
          {editMode ? (
            <Select
              value={{ value: selectedTimeZone, label: selectedTimeZone }}
              onChange={handleTimeZoneChange}
              e
              options={timeZones.map((tz) => ({ value: tz, label: tz }))}
              isSearchable={true}
              styles={{
                control: (base) => ({
                  ...base,
                  fontSize: 12,
                }),
              }}
            />
          ) : null}
        </div>
      )}

      {/* // ) : timeZones.length === 1 && (
      //   <div style={{ padding: "1%", whiteSpace: "nowrap" }}>
      //     <label style={{ fontSize: 12, fontWeight: "600" }}>Time Zone &nbsp;: &nbsp;</label>
      //     <label style={{ fontSize: 12 }}>{timeZones[0]}</label>
      //   </div>
      // )} */}

      <div style={{ padding: "1%", whiteSpace: "nowrap" }}>
        <AccessTimeIcon style={{ fontSize: 12 }} />
        &nbsp;
        <label style={{ fontSize: 12, fontWeight: "600" }}>
          Time Zone &nbsp;: &nbsp;
        </label>
        <label
          style={{ fontSize: 12 }}
        >{`(UTC${utcOffset}) ${selectedTimeZone}`}</label>
      </div>
      {editMode && (
        <div style={{ display: "flex", alignItems: "center" }}>
          <Tooltip title="Save Country and Time Zone" arrow>
            <SaveIcon
              style={{
                fontSize: 24,
                cursor: "pointer",
                color: "green",
                marginRight: "10px",
              }}
              onClick={handlePatchClick}
            />
          </Tooltip>
          <Tooltip title="Cancel" arrow>
            <CancelIcon
              style={{ fontSize: 24, cursor: "pointer", color: "red" }}
              onClick={handleCancelClick}
            />
          </Tooltip>
        </div>
      )}
    </div>
  );
}

export default Balancedays;
